import { Injectable } from '@angular/core';
import { TokenRefresherService } from './token-refresher.service';
import { UserIdleCheckerService } from './user-idle-checker.service';
import { Router } from '@angular/router';
import { OktaRoutes } from '../constants/route.constant';

//** 
// This will broadcast logout event to all tabs and browsers. 
// */
@Injectable({
  providedIn: 'root'
})
export class LogoutBroadcastService {

  private EVENT_NAME: string = 'logout-event';
  private broadcastChannel: BroadcastChannel = new BroadcastChannel('logout-channel');

  constructor(private tokenRefresherService: TokenRefresherService,
              private userIdleCheckerService: UserIdleCheckerService,
              private router: Router) { 
    this.initBroadcastListener();   
  }

  broadcastLogout(): void {
    this.broadcastChannel.postMessage({
      eventName: this.EVENT_NAME,
      payload: { message: 'Session has been logged out' }
    });
  }

  private initBroadcastListener(): void {
    this.broadcastChannel.addEventListener("message", (message) => this.handleBroadcastMessage(message));
  }

  private stopTimer(): void {
    this.tokenRefresherService.stopTimer();
    this.userIdleCheckerService.stopTimer();
  }

  private handleBroadcastMessage(message): void {
    if (message.data.eventName === this.EVENT_NAME) {
      this.stopTimer();
      this.router.navigateByUrl(OktaRoutes.Login.Url, { replaceUrl: true });
    };
  }

}
